import { AttachmentService } from '@fitness-force/api';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { NotFoundError } from '@fitness-force/errors';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import { ToastMessageService } from '@fitness-force/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FolderCreateDialogComponent } from '../../create-folder-dialog/folder-create-dialog.component';
import { AddAttachmentDialogComponent } from '../../add-attachment-dialog/add-attachment-dialog.component';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FileSaverService } from 'ngx-filesaver';
import { CONSTANTS_DATA } from '@fitness-force/constants';

@Component({
  selector: 'attachments',
  templateUrl: './attachments.component.html',
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    TranslateModule,
    BadgeModule,
    HttpClientModule]})
export class AttachmentsComponent implements OnInit {
  @Input() tenantId: number;
  @Input() clientId: number;
  @Input() attachmentsModal = false;
  @Input() showSelected = "Waiver";
  @Output() close = new EventEmitter();
  documentTypes!: any;
  documents: any
  documentsGrouped: any;
  deleteAttachmentModal = false;
  isSubmitting = false;
  activeDelete!: any;
  filterDocumentType = new BehaviorSubject<any>(null);
  activeFilter:any
  // TODO REMOVE ...
  selectedDocumentType: { name: string; } | undefined;


  refDialog?: DynamicDialogRef;
  constructor(private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private dialogService: DialogService,
    private attachmentService: AttachmentService,
    private toastMessageService: ToastMessageService,
    private httpClient:HttpClient,
    private cd: ChangeDetectorRef,
    private fileSaverService: FileSaverService
  ) { }

  ngOnInit(): void {
    this.getDocumentType();
  }

  getDocumentType() {
    const forkArray = [
      this.attachmentService.getAttachments(this.tenantId),
      this.attachmentService.getDocuments(this.clientId),
      this.attachmentService.getWaiversDocuments(this.tenantId, this.clientId)
  ];
    forkJoin(forkArray).subscribe(
      {
        next: (res: any) => {
          if (res && res[0]?.items && res[0]?.items?.length > 0) {
            this.documentTypes = res[0].items
          } else {
            this.documentTypes = [];
          }
          if (res && res[1] && res[1].items && res[1].items.length > 0) {
            this.documents = res[1].items;

            this.documentsGrouped = this.documents.reduce((r: any, a: any) => {
              r[a.document_type_id] = r[a.document_type_id] || [];
              r[a.document_type_id].push(a);
              return r;
            }, Object.create(null));
          } else {
            this.documents = [];
            this.documentsGrouped = null;
          }

          this.documentTypes.forEach((element:any) => {
            if(!this.documentsGrouped){
              this.documentsGrouped={}
            }
            if(!this.documentsGrouped[element?.id]){
              this.documentsGrouped[element?.id]=[];
            }
          });

          if (res && res[2] && res[2].items) {
            const completedWaivers = res[2].items.filter((element: any) => element.status.toLowerCase() === 'completed');
            const distinctWaiversMap = new Map<string, any>();
            completedWaivers.forEach((waiver: any) => {
              if (!distinctWaiversMap.has(waiver.guid)) {
                distinctWaiversMap.set(waiver.guid, waiver);
              }
            });
            const distinctWaivers = Array.from(distinctWaiversMap.values()); 
            const waverType = this.findWaiverType();
            distinctWaivers.forEach((element: any) => {
              this.documents.push(element);
              if (waverType && this.documentsGrouped && this.documentsGrouped[waverType.id]) {
                this.documentsGrouped[waverType.id] = this.documentsGrouped[waverType.id] ? this.documentsGrouped[waverType.id] : [];
                this.documentsGrouped[waverType.id].push(element)
              }
            });

          }
          this.filterDocumentType.next(this.documentTypes);
          if(this.showSelected != '') this.setFilterDocumentType(this.showSelected);
          this.cd.detectChanges();
        }, error: (error: any) => {
          this.handleError(error)
        }

      })
  }

  setFilterDocumentType(name: string | null = null) {
    if (name) {
    const filtered=  this.documentTypes.find((folder: any) => {
        return String(folder.name_primary_language).toLowerCase() === name.toLowerCase();
      })
      this.activeFilter=filtered;
      this.filterDocumentType.next([filtered]);
    }
    else {
      this.activeFilter=null;

      this.filterDocumentType.next(this.documentTypes);
    }
  }


  findWaiverType() {
    return this.documentTypes.find((folder: any) => {
      return String(folder.name_primary_language).toLowerCase() === CONSTANTS_DATA.WAVER_FOLDER_NAME;
    })
  }

  getDocumentCount(id: number): number {
    if (this.documentsGrouped[id]) {
      return this.documentsGrouped[id].length;
    } else {
      return 0;
    }
  }

  closeDialog() {
    this.attachmentsModal = false;
    this.close.emit(true);
  }

  activateDelete(item: any) {
    this.activeDelete = item;
    this.deleteAttachmentModal = true;
  }

  deleteDocument() {
    this.isSubmitting = true;
    this.attachmentService.deleteDocument(this.tenantId, this.clientId, this.activeDelete.id).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;
        this.activeDelete = null;
        this.deleteAttachmentModal = false;
        this.getDocumentType();
      },
      error: (error: any) => {
        this.isSubmitting = false;
        this.handleError(error)
      }
    })
  }

  handleError(error: any) {
    if (error instanceof NotFoundError) {
      this.translate
        .get(
          'common.errors.SERVER_SIDE.PAGE_NOT_FOUND'
        )
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    } else {
      this.translate
        .get( 
          'common.errors.SERVER_SIDE.SOMETHING_WRONG'
        )
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    }
  }


  addFolder(activeFolder: any = null) {
    this.refDialog = this.dialogService.open(FolderCreateDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      contentStyle: { 'max-height': '500px', 'min-width': '400px', 'max-width': '600px' },
      data: { activeFolder },
    });
    this.refDialog.onClose.subscribe((folder: any) => {
      if (folder) {
        this.getDocumentType();
      }
    });
  }

  uploadAttachment() {
    this.refDialog = this.dialogService.open(AddAttachmentDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      contentStyle: { 'min-width': '400px', 'max-width': '800px' },
      data: { clientId: this.clientId },
    });
    this.refDialog.onClose.subscribe((uploaded: any) => {
      if (uploaded) {
        this.getDocumentType();
      }
    });
  }


  getFileType(doc: any) {
    const ext = doc.file_name.split('.').pop();
    switch (ext) {
      case 'pdf':
        return 'pdf';
      //break;
      case 'png':
      case 'jpg':
      case 'gif':
      case 'jpeg':
        return 'image'
      default:
        return null
    }
  }

  getFileName(doc: any) {

    return doc.file_name ? doc.file_name.split('\\').pop() : 'Attachment';
  }
  getURL(doc:any){
    return doc?.waiver_signed_url?doc.waiver_signed_url:doc.document_signed_thumbnail_url;
  }


  onDown(doc:any) {
    const fileName = this.getFileName(doc);
    const url =doc?.waiver_signed_url?doc.waiver_signed_url:doc.document_signed_thumbnail_url
        this.httpClient
          .get(url, {
            observe: 'response',
            responseType: 'blob',
            headers:{skip:"true"}
          })
          .subscribe((res) => {
            this.fileSaverService.save(res.body, fileName);
          });
  }

}